import { css } from 'styled-components';
import { theme } from '../../theme';
import { BodySize } from '../typography';

export type InputWrapperStyleProps = {
  disabled: boolean;
  hasError: boolean;
  isFocussed?: boolean;
  readOnly: boolean;
};

export type FieldStyleProps = {
  isCompact?: boolean;
  haveMarginBottom: boolean;
  isFullWidth?: boolean;
};

export type InputStyleProps = {
  isCompact?: boolean;
  showPlaceholder?: boolean;
  textSize?: BodySize;
};

export const defaultInputHeight = '48px';

export const FieldStyles = css<FieldStyleProps>`
  ${({ haveMarginBottom }) =>
    haveMarginBottom && `margin-bottom: ${theme.spacings[4].rem};`}
  ${({ isCompact }) => isCompact && `position: relative;`}
`;

const InputFocusStyles = css`
  border: 1px solid ${theme.colors.system.systemBlue};
`;

export const InputWrapperStyles = css<InputWrapperStyleProps>`
  border: 1px solid
    ${({ hasError }) =>
      hasError
        ? theme.colors.system.systemRed
        : theme.colors.neutrals.solidGrays[5]};
  border-radius: 2px;
  box-sizing: border-box;
  overflow: hidden;
  transition: border 0.2s;

  ${({ disabled, readOnly }) =>
    (disabled || readOnly) &&
    `
      background-color: ${theme.colors.neutrals.transparentGrays[7]};
      pointer-events: none;
  `}

  ${({ hasError, isFocussed }) => isFocussed && !hasError && InputFocusStyles}

  &:focus,
  &:focus-visible,
  &:focus-within {
    ${({ hasError }) => !hasError && InputFocusStyles}
  }
`;

export const InputStyles = css<InputStyleProps>`
  ${({ textSize }) => theme.typography.body[textSize || 'md']}
  appearance: none;
  background: none;
  border: none;
  box-sizing: border-box;
  color: ${theme.colors.primary.graysGray};
  outline: none !important;
  padding: ${({ isCompact }) =>
    isCompact
      ? `${theme.spacings[5].rem} ${theme.spacings[3].rem} ${theme.spacings[2].rem}`
      : `${theme.spacings[3].rem} ${theme.spacings[2].rem}`};
  width: 100%;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button,
  &[type='number'] {
    -webkit-appearance: none;
    -moz-appearance: textfield;
  }

  ${({ showPlaceholder }) =>
    !showPlaceholder &&
    `
    ::-webkit-input-placeholder {
      color: transparent;
      opacity: 0;
    }
    :-moz-placeholder {
      color: transparent;
      opacity: 0;
    }
    ::-moz-placeholder {
      color: transparent;
      opacity: 0;
    }
  `}
`;

export const ErrorStyles = css`
  background-color: ${theme.colors.system.systemRedLite};
  border-radius: 2px;
  color: ${theme.colors.system.systemRed};
  margin-top: ${theme.spacings[1].rem};
  padding: ${theme.spacings[2].rem} ${theme.spacings[3].rem};
`;
